import React from 'react';
import { Spin } from 'antd';
import './ApplicablePeople.css';
import { useImages } from '../hooks/useImages';
import { getImageUrl } from '../utils/imageUtils';

const ApplicablePeople: React.FC = () => {
  // 从后台获取适用人群图片数据
  const { images, loading, error } = useImages('target_audience');

  // 如果正在加载，显示加载状态
  if (loading) {
    return (
      <section className="applicable-people section">
        <div className="people-loading">
          <Spin size="large" />
          <p>加载适用人群图片中...</p>
        </div>
      </section>
    );
  }

  // 如果有错误，显示错误信息
  if (error) {
    return (
      <section className="applicable-people section">
        <div className="people-error">
          <p>{error}</p>
        </div>
      </section>
    );
  }

  // 获取第一张适用人群图片
  const peopleImage = images.find(img => img.isActive);

  return (
    <section id="applicable-people" className="applicable-people section">
      {peopleImage ? (
        <img
          src={getImageUrl(peopleImage._id)}
          alt={peopleImage.alt || '适用人群'}
          className="people-image"
        />
      ) : (
        <div className="people-empty">
          <p>暂无适用人群图片</p>
        </div>
      )}
    </section>
  );
};

export default ApplicablePeople;  